import { FieldPath, FieldValues, useController } from "react-hook-form";
import {
  Autocomplete,
  AutocompleteRenderInputParams,
  FormControl,
  InputLabel,
} from "@mui/material";
import React from "react";
import { roleOptionsForMultiSelect } from "../Role";
import { RhfInputProps } from "../../Forms/RhfInputProps";
import { RHFFieldErrorText } from "../../Forms/RHFFieldErrorText";
import { TextFieldReadOnly } from "../../TransportNetwork/TTProtections/Form/AffectedSprs/MultiSelectMenues/TextFieldReadOnly";
import { textFieldDefaultProps } from "../../Forms/TextFieldDefaultProps";
import { MuiSelectChip } from "../../Layout/Select/MuiSelectChip";

type RhfRoleMultiSelectProps = { disabled?: boolean; label?: string };

export const RhfRoleMultiSelect = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
>({
  control,
  name,
  label,
  disabled,
}: RhfInputProps<TFieldValues, TName> & RhfRoleMultiSelectProps) => {
  const {
    field,
    fieldState: { error },
    formState: { disabled: isFormDisabled },
  } = useController({ control, name });

  const roles = roleOptionsForMultiSelect;
  const labels = Object.fromEntries(roles.map((role) => [role.Id, role.Name]));

  return (
    <FormControl fullWidth size="small">
      {label && <InputLabel shrink>{label}</InputLabel>}
      <Autocomplete
        {...field}
        multiple
        noOptionsText="No options available"
        options={roles.map((r) => r.Id)}
        getOptionLabel={(role) => labels[role] ?? "NOT FOUND"}
        onChange={(_, selectedValues) => field.onChange(selectedValues)}
        renderInput={(params: AutocompleteRenderInputParams) => (
          <TextFieldReadOnly {...params} {...textFieldDefaultProps} label={label} />
        )}
        renderTags={(values, getTagProps) =>
          values.map((value, index) => (
            <MuiSelectChip
              getTagProps={getTagProps}
              labels={labels}
              index={index}
              valueId={value}
            />
          ))
        }
        size="small"
        filterSelectedOptions
        disableCloseOnSelect
        disabled={disabled || isFormDisabled}
      />
      {!!error && <RHFFieldErrorText fieldError={error} />}
    </FormControl>
  );
};
